/*
 * File: /src/router/routes/reservations.js
 * Created Date: Thursday October 28th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 28th October 2021 10:41:16 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

const ReservationList = () =>
  import(
    /* webpackChunkName: "Reservation" */ 'src/components/Dashboard/Views/Reservations/ReservationList.vue'
  );
const ReservationGapList = () =>
  import(
    /* webpackChunkName: "Reservation" */ 'src/components/Dashboard/Views/Reservations/ReservationGapList.vue'
  );

export const reservationRoutes = [
  {
    path: 'reservations',
    name: 'Reservations',
    component: ReservationList,
    props: (route) => ({
      queryFilterBy: route.query.filterBy
        ? Array.isArray(route.query.filterBy)
          ? route.query.filterBy
          : [route.query.filterBy]
        : [],
      queryResId: route.query.resId || undefined,
      queryName: route.query.name || undefined,
      queryArrivalDate:
        route.query.arrivalStart && route.query.arrivalEnd
          ? [
              new Date(route.query.arrivalStart),
              new Date(route.query.arrivalEnd),
            ]
          : undefined,
      queryDepartureDate:
        route.query.departureStart && route.query.departureEnd
          ? [
              new Date(route.query.departureStart),
              new Date(route.query.departureEnd),
            ]
          : undefined,
      queryContractDate:
        route.query.contractStart && route.query.contractEnd
          ? [
              new Date(route.query.contractStart),
              new Date(route.query.contractEnd),
            ]
          : undefined,
      queryChannel: route.query.channel || undefined,
      queryResType: route.query.resType || undefined,
      queryUnits: route.query.unitId
        ? Array.isArray(route.query.unitId)
          ? route.query.unitId.map((v) => parseInt(v))
          : [parseInt(route.query.unitId)]
        : [],
      queryPropertyName: route.query.propertyName || undefined,
      queryConnectorId: route.query.connectorId
        ? parseInt(route.query.connectorId)
        : undefined,
      queryCancelled: route.query.cancelled || undefined,
      queryTags: route.query.tags
        ? Array.isArray(route.query.tags)
          ? route.query.tags.map((v) => parseInt(v))
          : [parseInt(route.query.tags)]
        : [],
      queryPage: route.query.page ? parseInt(route.query.page) : undefined,
      queryLimit: route.query.limit ? parseInt(route.query.limit) : undefined,
      queryPageBefore: route.query.pageBefore
        ? parseInt(route.query.pageBefore)
        : undefined,
      queryPageAfter: route.query.pageAfter
        ? parseInt(route.query.pageAfter)
        : undefined,
    }),
  },
  {
    path: 'reservations/gap-night',
    name: 'Reservation Gap Nights',
    component: ReservationGapList,
  },
];
